import React, { useState } from 'react';
import {
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
    Label,
    Input,
    Button
} from 'reactstrap';
import API from "../../services/api";
import { API_REQUEST } from "../../constants/General";
import { EVENT_PAYMENT_API } from "../../constants/Configs";

const TicketModal = ({
    isOpen,
    toggle,
    ticket,
    event,
    increaseQuantity,
    decreaseQuantity,
    getTotalPrice,
    setSelectedTickets,
    selectedSlotId
}) => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [mobileNo, setMobileNo] = useState('');
    const [email, setEmail] = useState('');
    const [donte, setDonte] = useState('');
    const [errorMessage, setErrorMessage] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({});

    const SERVICE_CHARGE_PERCENTAGE = 5; // 5% service charge

    const SERVICE_CHARGE_FLAT = 1.5; // 5% service charge

    function validateOrderData(orderData) {
        const errors = {};
        const isValidString = (val) => typeof val === "string" && val.trim() !== "";
        const isValidMobile = (num) => /^[0-9]{10}$/.test(num);

        if (!isValidString(orderData.firstName)) errors.firstName = "First name is required.";
        if (!isValidString(orderData.lastName)) errors.lastName = "Last name is required.";
        if (!isValidString(orderData.email)) errors.email = "Email is required.";
        if (!isValidMobile(orderData.phone)) errors.phone = "Mobile number must be 10 digits.";

        if (Object.keys(errors).length > 0) {
            setFieldErrors(errors);
            return { success: false, message: "Please fix the errors above." };
        }

        setFieldErrors({});
        return { success: true, message: "Validation passed." };
    }

    const calculateServiceCharge = (baseAmount) => {
        return ((baseAmount * SERVICE_CHARGE_PERCENTAGE) / 100) + SERVICE_CHARGE_FLAT;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const ticketQty = Object.entries(ticket)
            .filter(([key]) => key !== "total")
            .map(([ticketId, ticketQuantity]) => ({
                ticketId: Number(ticketId),
                ticketQuantity
            }));

        const baseTotal = parseFloat(ticket.total.toFixed(2)) || parseFloat(donte) || 0;
        const serviceCharge = calculateServiceCharge(baseTotal);
        const totalWithService = baseTotal + serviceCharge;

        const paymentData = {
            firstName,
            lastName,
            email,
            phone: mobileNo,
            eventId: event.id,
            slotId: selectedSlotId,
            ticketQuantity: ticketQty.flatMap(({ ticketId, ticketQuantity }) =>
                Array(ticketQuantity).fill({ ticketId, ticketQuantity: 1 })
            ),
            addonQuantity: [],
            currency: "gbp",
            orderStatus: "pending",
            orderDateTime: new Date().toISOString(),
            orderPaymentType: "Online",
            grossSales: totalWithService,
            netSales: baseTotal,
            netRevenue: baseTotal,
            wpServiceFee: serviceCharge,
            restaurantId: event.restaurantId
        };

        try {
            const { success, message } = validateOrderData(paymentData);
            if (success) {
                const response = await API(API_REQUEST.post, EVENT_PAYMENT_API, paymentData);
                if (response?.data?.data?.url) {
                    window.location.href = response.data.data.url;
                }
            } else {
                setErrorMessage(message);
            }
        } catch (error) {
            console.error('Error creating payment intent:', error);
            setErrorMessage("Something went wrong while processing your request.");
        }
    };

    const baseAmount = parseFloat(ticket?.total?.toFixed(2)) || parseFloat(donte) || 0;
    const serviceCharge = calculateServiceCharge(baseAmount);
    const totalWithService = (baseAmount + serviceCharge).toFixed(2);

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>Purchase Ticket: {ticket.ticketName}</ModalHeader>
            <ModalBody>
                {errorMessage && <p className="text-danger">{errorMessage}</p>}
                <FormGroup>
                    <Label for="firstName">First Name</Label>
                    <Input
                        type="text"
                        id="firstName"
                        className={fieldErrors.firstName ? "is-invalid" : ""}
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                    />
                    {fieldErrors.firstName && <div className="invalid-feedback">{fieldErrors.firstName}</div>}
                </FormGroup>
                <FormGroup>
                    <Label for="lastName">Last Name</Label>
                    <Input
                        type="text"
                        id="lastName"
                        className={fieldErrors.lastName ? "is-invalid" : ""}
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                    />
                    {fieldErrors.lastName && <div className="invalid-feedback">{fieldErrors.lastName}</div>}
                </FormGroup>
                <FormGroup>
                    <Label for="mobileNo">Mobile Number</Label>
                    <Input
                        type="tel"
                        id="mobileNo"
                        className={fieldErrors.phone ? "is-invalid" : ""}
                        value={mobileNo}
                        onChange={(e) => setMobileNo(e.target.value)}
                    />
                    {fieldErrors.phone && <div className="invalid-feedback">{fieldErrors.phone}</div>}
                </FormGroup>
                <FormGroup>
                    <Label for="email">Email</Label>
                    <Input
                        type="email"
                        id="email"
                        className={fieldErrors.email ? "is-invalid" : ""}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    {fieldErrors.email && <div className="invalid-feedback">{fieldErrors.email}</div>}
                </FormGroup>

                <FormGroup>
                    <Label for="quantity">Select Ticket Quantity</Label>
                    {event.tickets.map((ticketdata) => (
                        <div key={ticketdata.id} className="bg-white p-3 rounded border mb-2">
                            <p className="mb-1"><strong>{ticketdata.ticketName}</strong></p>
                            <div className="d-flex justify-content-between align-items-center">
                                <span>£{ticketdata.ticketPrice}</span>
                                <div>
                                    <Button color='primary' className="text-dark" size='sm' onClick={() => decreaseQuantity(ticketdata.id)}>-</Button>
                                    <span style={{marginRight:"7px"}} >{ticket[ticketdata.id] || 0}</span>
                                    <Button color='primary' className="text-dark" size='sm' onClick={() => increaseQuantity(ticketdata.id)}>+</Button>
                                </div>
                            </div>
                        </div>
                    ))}
                </FormGroup>

                <FormGroup>
                    {event.tickets[0].isDonationEvent === "yes" && (
                        <>
                            <Label for="donationAmount">Donation Amount</Label>
                            <Input
                                type="number"
                                id="donationAmount"
                                value={donte}
                                onChange={(e) => setDonte(e.target.value)}
                            />
                        </>
                    )}
                </FormGroup>

                <FormGroup>
                    <Label>Service Charge (5%)</Label>
                    <Input type="text" readOnly value={`£${serviceCharge.toFixed(2)}`} />
                </FormGroup>

                <FormGroup>
                    <Label>Total Price</Label>
                    <Input
                        type="text"
                        value={`£${totalWithService}`}
                        readOnly
                    />
                </FormGroup>

                <div className="d-flex justify-content-end mt-4">
                    <Button color="primary" onClick={handleSubmit} className="me-2">Buy Now</Button>
                    <Button color="secondary" onClick={toggle}>Cancel</Button>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default TicketModal;
